import React, { FC } from 'react';
import { Box, Container, Grid, Skeleton } from '@mui/material';
import StyledBox from 'views/rebranded-module/OffRoadToursLandingViewV2/components/OffRoadAdventuresExperiencesSection/OffRoadAdventuresExperiencesSection.styles';

const OffRoadAdventuresExperiencesSectionSkeleton: FC = () => {
  return (
    <StyledBox py={14}>
      <Container>
        <Grid container spacing={8}>
          {/* Image Section */}
          <Grid item lg={6} md={12} sm={12}>
            <Box className="OAESImage">
              {/* Main Image Skeleton */}
              <Skeleton variant="rectangular" width="100%" height="100%" />
              
              {/* Sub Image Skeleton */}
              <Box className="OAESSubImg">
                <Skeleton variant="rectangular" width="100%" height="100%" />
              </Box>
            </Box>
          </Grid>

          {/* Content Section */}
          <Grid item lg={6} md={12} sm={12}>
            {/* Title Skeleton */}
            <Skeleton variant="text" width="80%" height={48} />
            
            {/* Description Skeleton */}
            <Box my={2}>
              <Skeleton variant="text" width="100%" height={24} />
              <Skeleton variant="text" width="95%" height={24} />
              <Skeleton variant="text" width="90%" height={24} />
            </Box>
            
            {/* List Items Skeleton */}
            <Box>
              {[...Array(4)].map((_, item) => (
                <Box 
                  key={item} 
                  className="OAESListItem" 
                  sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}
                >
                  {/* Icon Skeleton */}
                  <Skeleton 
                    variant="rectangular" 
                    width={24} 
                    height={24} 
                    sx={{ borderRadius: 1, mr: 2, flexShrink: 0 }} 
                  />
                  
                  {/* Benefit Text Skeleton */}
                  <Box className="OAESBenfites" sx={{ flex: 1 }}>
                    <Skeleton variant="text" width="95%" height={24} />
                  </Box>
                </Box>
              ))}
            </Box>
          </Grid>
        </Grid>
      </Container>
    </StyledBox>
  );
};

export { OffRoadAdventuresExperiencesSectionSkeleton };